import React from 'react';
import { Check } from 'lucide-react';
import ReservationDialog from './ReservationDialog';
import { aboutImage } from '../mock';

const About = () => {
  return (
    <section id="about" className="py-16 lg:py-24 section-soft">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="relative reveal order-2 lg:order-1">
          <div className="rounded-3xl overflow-hidden shadow-2xl">
            <img
              src={aboutImage}
              alt="Outlet Trust Me Laundry"
              className="w-full h-[340px] sm:h-[420px] lg:h-[480px] object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-6 -left-2 sm:-left-4 lg:-left-8 bg-white rounded-2xl shadow-xl p-4 sm:p-5 flex items-center gap-3 sm:gap-4 border border-[color:var(--brand-50)]">
            <div className="h-12 w-12 sm:h-14 sm:w-14 rounded-xl bg-[color:var(--brand)] text-white flex items-center justify-center font-extrabold text-lg sm:text-xl flex-shrink-0">5+</div>
            <div>
              <div className="text-[10px] sm:text-xs uppercase tracking-wider text-[color:var(--muted)]">Tahun Pengalaman</div>
              <div className="font-display font-bold text-[color:var(--ink)] text-sm sm:text-base">Terpercaya & Profesional</div>
            </div>
          </div>
        </div>

        <div className="reveal order-1 lg:order-2">
          <span className="inline-block px-3 py-1 rounded-full bg-[color:var(--brand-50)] text-[color:var(--brand)] text-xs font-semibold tracking-wider uppercase mb-3">Tentang Kami</span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[color:var(--ink)] leading-tight">
            Laundry <span className="text-[color:var(--brand)]">Bersih</span>, Wangi, Higienis, dan Tepat Waktu
          </h2>
          <p className="text-[color:var(--muted)] mt-5 leading-relaxed">
            <b>Trust Me Laundry</b> — Layanan laundry kiloan dan satuan profesional yang bersih, rapi, higienis, dan tepat waktu. Melayani kebutuhan personal maupun korporat (kantor, RS, sekolah, dll). Hubungi kami untuk penawaran harga khusus dengan kontrak minimal 3 bulan.
          </p>

          <ul className="mt-6 grid sm:grid-cols-2 gap-3">
            {['Stop Mencuci Sendiri','1 Mesin 1 Customer','Detergent Premium & Aman','Garansi Cucian Bersih'].map((t) => (
              <li key={t} className="flex items-center gap-3 text-[color:var(--ink)]">
                <span className="h-6 w-6 rounded-full bg-[color:var(--brand)] text-white flex items-center justify-center flex-shrink-0"><Check className="w-4 h-4" /></span>
                <span className="font-medium text-sm sm:text-base">{t}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-wrap gap-3">
            <ReservationDialog trigger={<button className="btn-brand">Reservasi Sekarang</button>} />
            <a href="#services" className="btn-brand-outline">Lihat Layanan</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
